module.exports = __webpack_public_path__ + "static/clarity-research-a46845d19a879294deb41ad99081d00f.svg";